import 'css-chunksrc/client/pages/projectPage/kanbanPage/statusCreationForm/styles.scss';export default {
  "switch": "_switch_19hzu_1"
};